<div [formGroup]="form" class="form-grid">
  <ng-container formArrayName="roles">
    <div *ngFor="let control of form.controls.roles.controls; let i = index" class="d-flex flex-column gap-2">
      <label [for]="'role-' + (i + 2)" class="form-input-label" i18n>Role {{ i + 2 }}</label>
      <app-dropdown-input
        [formControl]="control"
        [controlId]="'role-' + (i + 2)"
        [dropdowns]="roleDropdowns"
        [clearable]="true" />
      <div class="form-input-hint" i18n>Optional</div>
    </div>
  </ng-container>
</div>
<div [style.margin-top.rem]="1.5" *ngIf="form.controls.roles.length + 1 < roleDropdowns.length">
  <app-tertiary-button
    [leftIconSrc]="'assets/icons/primary/Plus.svg'"
    [size]="BaseButtonSizeEnum.md"
    (buttonClicked)="addRole.emit()"
    i18n>
    Add Another Role
  </app-tertiary-button>
</div>
